import {
  generateAsyncSelectors,
  typedDelegateSelectors,
} from "chat/imports/state";
import { LiveBarState } from "chat/liveBar/state/slice";

const { data, meta } = generateAsyncSelectors<LiveBarState>();

const localLiveBarSelectors = {
  data,
  meta,
  getIsInitialized: (state: LiveBarState) => state?.data?.isInitialized,
  getStreamList: (state: LiveBarState) => state?.data?.streamList,
  getLastTimestamp: (state: LiveBarState) => state?.data?.lastTimestamp,
  getHasMore: (state: LiveBarState) => state?.data?.hasMore,
  getLoading: (state: LiveBarState) => state?.meta?.loading,
};

export const liveBarSelectors = typedDelegateSelectors(
  localLiveBarSelectors,
  "liveBar"
);
